var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Public',{staticClass:"tw-h-screen"},[_c('v-main',[_c('about'),_c('feature'),_c('supported-ecommerce-list'),_c('supported-program-list'),_c('lead-footer'),_c('contact'),_c('footer-web')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }